import {useMemo} from 'react';
import {useDispatch} from 'react-redux';
import EarlyAccessFeatureManager from 'app/earlyAccess/EarlyAccessFeatureManager';
import useEarlyAccessFeatureSelector from 'app/hooks/useEarlyAccessFeatureSelector';

const useEarlyAccessFeatures = (features?: string[]) => {
  const dispatch = useDispatch();
  const earlyAccessFeaturesStore = useEarlyAccessFeatureSelector();

  return useMemo(() => {
    const manager = new EarlyAccessFeatureManager(dispatch, earlyAccessFeaturesStore, features);
    return {
      earlyAccessFeatures: manager.getFeatures(),
      submitConsentChanges: manager.submitConsentChanges,
    };
  }, [dispatch, earlyAccessFeaturesStore, features]);
};

export {useEarlyAccessFeatures};
